import { throttle } from './utils';
var lzCount = 0;
/**
 * 图片懒加载
 */
var Lazyload = /* @__PURE__ */ (function () {
    function Lazyload(_a) {
        var _b = _a === void 0 ? {
            offset: 0,
            isLazy: true,
            srcFlag: 'data-src',
            scrollTarget: window
        } : _a, img = _b.img, _c = _b.isLazy, isLazy = _c === void 0 ? true : _c, _d = _b.srcFlag, srcFlag = _d === void 0 ? 'data-src' : _d, _e = _b.offset, offset = _e === void 0 ? 0 : _e, _f = _b.scrollTarget, scrollTarget = _f === void 0 ? window : _f;
        this.imgsArr = [];
        this.imgs = img;
        this.isLazy = isLazy;
        this.srcFlag = srcFlag;
        this.offset = offset;
        this.scrollTarget = scrollTarget;
        this.init();
    }
    Lazyload.prototype.init = function () {
        var _this = this;
        lzCount += 1;
        this.loadImgCount = 0;
        // @ts-ignore
        var isIE = !!window.ActiveXObject || 'ActiveXObject' in window;
        var milliseconds = isIE ? 500 : 20; // IE hack处理
        setTimeout(function () {
            _this.fill();
        }, milliseconds);
    };
    Lazyload.prototype.reset = function () {
        this.init();
    };
    /**
     * 追加图片
     * @param opt
     */
    Lazyload.prototype.append = function (opt) {
        this.imgsArr.push(opt.img);
    };
    Lazyload.prototype.fill = function () {
        var _this = this;
        this.imgsArr = this.imgs || Array.from(document.querySelectorAll("img[".concat(this.srcFlag, "]")));
        this.handleScroll();
        if (this.isLazy) {
            this.scrollThrottle = throttle(function () {
                _this.handleScroll();
            }, 100);
            this.scrollTarget.addEventListener('scroll', this.scrollThrottle);
        }
    };
    Lazyload.prototype.handleScroll = function () {
        if (this.isLazy) {
            var screenH = window.innerHeight || document.documentElement.clientHeight;
            var scrollT = document.body.scrollTop || document.documentElement.scrollTop;
            for (var i = 0; i < this.imgsArr.length; i += 1) {
                var img = this.imgsArr[i];
                var _a = img.getBoundingClientRect(), top_1 = _a.top, height = _a.height;
                var dataSrc = img.getAttribute(this.srcFlag);
                if (screenH + scrollT + this.offset >= top_1 &&
                    top_1 + height > 0 &&
                    top_1 < screenH &&
                    dataSrc) {
                    this.loadImg(img);
                    img.removeAttribute(this.srcFlag);
                }
            }
        }
        else {
            for (var i = 0; i < this.imgsArr.length; i += 1) {
                var img = this.imgsArr[i];
                this.loadImg(img);
                img.removeAttribute(this.srcFlag);
            }
        }
    };
    /**
     * 加载图片
     * @param img
     */
    Lazyload.prototype.loadImg = function (img) {
        var _this = this;
        var imgSrc = img.getAttribute(this.srcFlag);
        if (img && imgSrc) {
            var lzSrc_1 = imgSrc;
            if (img.complete) {
                this.replaceImg(img, lzSrc_1);
            }
            else {
                var preload_1 = new Image();
                preload_1.onload = function () {
                    preload_1.onload = null;
                    _this.replaceImg(img, lzSrc_1);
                };
                preload_1.onerror = function () {
                    preload_1.onerror = null;
                    _this.loadImgCount += 1;
                };
                preload_1.src = lzSrc_1;
            }
        }
    };
    /**
     * 手动触发懒加载目标dom内的图片
     * @param target 目标dom
     */
    Lazyload.prototype.loadTargetImgs = function (target) {
        var imgsArr = Array.from(target.querySelectorAll("img[".concat(this.srcFlag, "]")));
        if (imgsArr.length) {
            for (var i = 0; i < imgsArr.length; i += 1) {
                var img = imgsArr[i];
                this.loadImg(img);
                img.removeAttribute(this.srcFlag);
            }
        }
    };
    /**
     * 替换图片
     * @param target
     * @param url
     */
    Lazyload.prototype.replaceImg = function (target, url) {
        var _this = this;
        var load = function () {
            _this.afterReplace();
            target.removeEventListener('load', load);
        };
        target.addEventListener('load', load);
        target.setAttribute('src', url);
    };
    Lazyload.prototype.afterReplace = function () {
        this.loadImgCount += 1;
        this.checkFinish();
    };
    Lazyload.prototype.checkFinish = function () {
        if (this.loadImgCount === this.imgsArr.length) {
            lzCount -= 1;
            if (!lzCount) {
                this.destroy();
            }
        }
    };
    Lazyload.prototype.destroy = function () {
        this.scrollTarget.removeEventListener('scroll', this.scrollThrottle);
    };
    return Lazyload;
}());
export { Lazyload };
